import React from 'react';
import { Users, Award, Target, Heart } from 'lucide-react';

const Distributor = () => {
  return (
    <div className="min-h-screen bg-black pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Devenez Distributeur
          </h1>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Rejoignez notre réseau de distributeurs et profitez d'avantages exclusifs pour votre entreprise
          </p>
        </div>

        {/* Hero Image */}
        <div className="mb-16 rounded-lg overflow-hidden">
          <img loading="lazy"
            src="https://partyled.ae/cdn/shop/files/Party_LED_1024_x_1024_px_15.png?v=1748864228&width=3840"
            alt="Distributeur Party LED"
            className="w-full h-96 object-cover"
          />
        </div>

        {/* Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="bg-gray-900 rounded-lg p-6 text-center hover:bg-gray-800 transition-colors">
            <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">Réseau Exclusif</h3>
            <p className="text-gray-400">
              Intégrez un réseau de distributeurs professionnels
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 text-center hover:bg-gray-800 transition-colors">
            <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">Tarifs Préférentiels</h3>
            <p className="text-gray-400">
              Bénéficiez de remises jusqu'à 40% sur nos produits
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 text-center hover:bg-gray-800 transition-colors">
            <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Target className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">Support Dédié</h3>
            <p className="text-gray-400">
              Accès à un support technique et commercial prioritaire
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 text-center hover:bg-gray-800 transition-colors">
            <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-white text-xl font-bold mb-2">Marketing</h3>
            <p className="text-gray-400">
              Matériel marketing et formations gratuites
            </p>
          </div>
        </div>

        {/* Content Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-gray-900 rounded-lg p-8">
            <h2 className="text-3xl font-bold text-white mb-6" style={{ fontFamily: 'Georgia, serif' }}>
              Pourquoi devenir distributeur ?
            </h2>
            <div className="space-y-4 text-gray-300">
              <p>
                En tant que distributeur officiel de Party LED, vous accédez à une gamme complète de produits LED innovants pour événements, concerts et festivités.
              </p>
              <p>
                Nous offrons des produits de qualité professionnelle avec une technologie de pointe, idéaux pour les organisateurs d'événements, les salles de concert, et les entreprises de divertissement.
              </p>
              <p>
                Notre engagement : vous fournir les meilleurs produits au meilleur prix, avec un support technique et commercial de premier ordre.
              </p>
            </div>
          </div>

          <div className="bg-gray-900 rounded-lg p-8">
            <h2 className="text-3xl font-bold text-white mb-6" style={{ fontFamily: 'Georgia, serif' }}>
              Conditions requises
            </h2>
            <ul className="space-y-4 text-gray-300">
              <li className="flex items-start">
                <span className="text-purple-500 mr-3 text-xl">•</span>
                <span>Entreprise enregistrée dans l'Union Européenne</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-500 mr-3 text-xl">•</span>
                <span>Expérience dans le secteur de l'événementiel ou de l'éclairage</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-500 mr-3 text-xl">•</span>
                <span>Capacité d'achat minimum de 5 000€ par trimestre</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-500 mr-3 text-xl">•</span>
                <span>Engagement à respecter nos standards de qualité</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-500 mr-3 text-xl">•</span>
                <span>Disponibilité pour des formations produits</span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-lg p-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Intéressé par un partenariat ?
          </h2>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Contactez notre équipe commerciale pour discuter des opportunités de distribution et recevoir notre brochure détaillée.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:distribution@party-led.com"
              className="bg-white text-purple-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors inline-block"
            >
              Nous contacter
            </a>
            <a
              href="tel:+33123456789"
              className="bg-transparent border-2 border-white text-white hover:bg-white/10 px-8 py-3 rounded-lg font-semibold transition-colors inline-block"
            >
              Appeler maintenant
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Distributor;